import { useQuery } from '../useQuery/useQuery'
import { usePermission } from '../usePermission/usePermission'

import { scope } from '@percent/workplace-giving/common/hoc/withPermissions'
import {
  getNonprofitPartnerTagAssignments,
  NonprofitPartnerTagAssignment
} from '@percent/workplace-giving/api/tags/getNonprofitPartnerTagAssignments/getNonprofitPartnerTagAssignments'

export const useNonprofitPartnerTagAssignments = (): NonprofitPartnerTagAssignment[] => {
  const has = usePermission()
  const hasContentTagsScope = has(scope('content_tags'))

  const { data } = useQuery(['getNonprofitPartnerTagAssignments'], getNonprofitPartnerTagAssignments, {
    enabled: hasContentTagsScope
  })

  return data ?? []
}
